import { ProductStockStatus } from '@pylot-data/enums/ProductStockStatus.d'
import { useTranslation } from 'next-i18next'
import { BundleTypeProps, SelectedBundleProducts } from './type'
import { sortAlphabetically } from '@components/alfakher/pylot-utils'
import formStyles from '@commonStyles/Forms.module.scss'
import { MediaGalleryInterface } from '@pylot-data/fwrdschema'
import { getDynamicPriceToAdd } from '@components/BundleProduct/Util/Prices'
import { BundleItemOption } from '@pylot-data/pylotschema'

export const Checkbox = ({
    selectedBundleProducts,
    setSelectedBundleProducts,
    bundleItem,
    setSelectedLabels,
    selectedLabels,
    dynamicPrice,
    currency,
    locale,
    mainFinalPrice,
    useFlavour = false
}: BundleTypeProps) => {
    const { options, uid } = bundleItem
    const { t } = useTranslation('common')
    const selectedUids =
        (selectedBundleProducts[uid as string]
            ?.uid as SelectedBundleProducts[]) ?? []
    const active = selectedUids?.map((i) => i.multiSelectUid)

    const filteredProduct = bundleItem.options?.filter((val) => {
        if (val?.label) {
            return val
        }
    })
    const sortedValues = filteredProduct?.sort((a, b) =>
        sortAlphabetically(a?.label, b?.label)
    )
    const isInstock = options?.find(
        (res) => res?.product?.stock_status === 'IN_STOCK'
    )
    return (
        <>
            {!isInstock ? (
                <div className={formStyles.root}>
                    <div className="pb-1 block">
                        <input
                            type="checkbox"
                            className="form-checkbox"
                            checked
                        />
                        <label className="label ml-2">
                            {t('All options are out of stock')}
                        </label>
                    </div>
                </div>
            ) : (
                ''
            )}
            {sortedValues?.map((v, i: number) => {
                const getOption = () => {
                    const flavourText = v?.product?.flavour_text

                    if (useFlavour && flavourText) {
                        return flavourText
                    }

                    return v?.label
                }

                const values: string = v?.product?.stock_status ?? ''
                const OutOfstockValue: boolean = ProductStockStatus.OutOfStock.includes(
                    values
                )
                if (!OutOfstockValue) {
                    return (
                        <div
                            className={formStyles.root}
                            key={`checkbox-${v?.uid}`}
                        >
                            <div className="pb-1 block">
                                <input
                                    type="checkbox"
                                    className="form-checkbox"
                                    onChange={(e) => {
                                        e.persist()
                                        const productUid = e.target.value
                                        const selectedOption = options?.find(
                                            (i) => productUid == i?.uid
                                        )
                                        const getFlavour = () => {
                                            const flavour = selectedOption
                                                ?.product?.flavour_text
                                                ? selectedOption?.product
                                                      .flavour_text
                                                : ''

                                            if (!flavour) {
                                                return getLabel()
                                            }

                                            return flavour
                                        }
                                        const getLabel = () => {
                                            return selectedOption?.label
                                                ? selectedOption?.label
                                                : ''
                                        }
                                        let labels: string[] =
                                            selectedLabels[uid as string] || []
                                        let selectedUidArray: SelectedBundleProducts[] = selectedUids
                                        let selectedGallery: MediaGalleryInterface[] = []
                                        if (active.includes(productUid)) {
                                            selectedUidArray = selectedUids.filter(
                                                (i) =>
                                                    productUid !=
                                                    i.multiSelectUid
                                            )
                                            labels = labels.filter(
                                                (label) =>
                                                    label !==
                                                    (useFlavour
                                                        ? getFlavour()
                                                        : getLabel())
                                            )
                                        } else {
                                            selectedUidArray = [
                                                ...selectedUids,
                                                {
                                                    multiSelectUid: productUid,
                                                    value:
                                                        selectedOption?.quantity ??
                                                        1
                                                }
                                            ]
                                            labels = [
                                                ...labels,
                                                (useFlavour
                                                    ? getFlavour()
                                                    : getLabel()) as string
                                            ]
                                        }
                                        const uidsArray = selectedUidArray.map(
                                            (opt) => opt.multiSelectUid
                                        )
                                        options?.forEach((opt) => {
                                            if (uidsArray.includes(opt?.uid!)) {
                                                selectedGallery = selectedGallery.concat(
                                                    opt?.product
                                                        ?.media_gallery as MediaGalleryInterface
                                                )
                                            }
                                        })
                                        setSelectedBundleProducts(
                                            {
                                                ...selectedBundleProducts,
                                                [uid as string]: {
                                                    uid: selectedUidArray
                                                }
                                            },
                                            selectedGallery
                                        )
                                        setSelectedLabels({
                                            ...selectedLabels,
                                            [uid as string]: labels
                                        })
                                    }}
                                    value={v?.uid}
                                    checked={active.includes(v?.uid as string)}
                                    disabled={
                                        v?.product?.stock_status ===
                                        ProductStockStatus.OutOfStock
                                    }
                                    id={v?.uid}
                                />
                                <label htmlFor={v?.uid} className="label ml-2">
                                    {getOption()}
                                    {getDynamicPriceToAdd(
                                        v as BundleItemOption,
                                        dynamicPrice,
                                        currency,
                                        locale,
                                        mainFinalPrice
                                    )}
                                </label>
                            </div>
                        </div>
                    )
                }
            })}
        </>
    )
}

export default Checkbox
